import { DistrictAttendanceLogs } from "./DistrictAttendance";


export const DistrictAttendanceReport = {
  "sections": [
    DistrictAttendanceLogs
  ]
}